import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useMediaQuery, Grid2, Button } from '@mui/material';

import Layout from 'components/Layout';
import { Title, BasicTable, SearchBox, PaginationControlled, CircularIndeterminate } from '@utriper/core-ui';
import { useContract } from 'core/contexts/contract';

import { useStyles } from './styles';
import { Contract, ContractStatus } from '@utriper/core';
import { useTranslation } from 'react-i18next';

const ContractsPage = () => {
    const { i18n } = useTranslation();
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('md'));
    const { getContracts, contracts, loading, total } = useContract();

    const classes = useStyles();
    const history = useHistory();

    const [nameSearch, setNameSearch] = useState('');

    const [page, setPage] = useState(1);
    const MAX_PAGE = 20;

    useEffect(() => {
        getContracts({
            nameSearch,
            pager: {
                page,
                pageSize: MAX_PAGE,
            },
        });
    }, [page, nameSearch]);

    const columns = [
        { align: 'left', val: 'id', label: 'Id' },
        { val: 'name', label: 'Name' },
        { val: 'contactEmail', label: 'Admin Email' },
        { val: 'notificationEmail', label: 'Notification Email' },
        { val: 'createdOn', label: 'Created On' },
        { val: 'location', label: 'Location' },
        { val: 'contractType', label: 'Contract Type', align: 'center' },
        { align: 'center', val: 'status', label: 'Status' },
        { align: 'center', val: 'hasQR', label: "QR" },
    ];

    const mobileColumns = [
        { align: 'left', val: 'id', label: 'Id' },
        { val: 'name', label: 'Name' },
        { val: 'contactEmail', label: 'Admin Email' },
        { val: 'contractType', label: 'Contract Type' },
        { align: 'center', val: 'status', label: 'Status' },
    ];

    const prettifyContracts = (contracts = []) =>
        contracts.map((contract) => ({
            ...contract,
            contractType: Contract.getTranslatedName(Contract.types, contract?.contractType ? contract?.contractType : contract?.isQR ? Contract.IDS.qr : Contract.IDS.catalog, i18n.language),
            status: ContractStatus.getTranslatedName(ContractStatus.status, contract?.status, i18n.language),
        }));

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const onChangeNameSearch = (event) => {
        setNameSearch(event.target.value);
        if (page !== 1) {
            setPage(1);
        }
    };

    const onClick = (event, id) => {
        history.push(`/contract/${id}`);
    };

    return (
        <Layout contentClassName={classes.content}>
            <Title value={'Contracts'} />
            <div style={{ marginBottom: '25px' }}>
                <Grid2 container justifyContent="space-between" alignItems="center">
                    <SearchBox onChange={onChangeNameSearch} value={nameSearch} label={'Name'} style={{ width: isSmall ? '10rem' : '14rem'}} />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={(e) => {
                            history.push(`/contract/0`);
                        }}>
                        ADD
                    </Button>
                </Grid2>
            </div>
            <div>
                {loading ? (
                    <CircularIndeterminate />
                ) : (
                    <>
                        <BasicTable columns={!isSmall ? columns : mobileColumns} values={prettifyContracts(contracts)} onClick={onClick} />
                        <br />
                        <Grid2 container justifyContent="center" alignItems="center">
                            <Grid2 >{total / MAX_PAGE < 1 ? null : <PaginationControlled count={Math.ceil(total / MAX_PAGE)} page={page} onChange={handlePageChange} totalItems={total} itemsPerPage={MAX_PAGE} />}</Grid2>
                        </Grid2>
                    </>
                )}
            </div>
        </Layout>
    );
};

ContractsPage.displayName = 'ContractsPage';

export default ContractsPage;
